import { Statistics } from '@/models/leaderboard';
import { GETTERS as LEADERBOARD_GETTERS } from '@/store/leaderboard';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardRanks',
})
export default class CmgLeaderboardRanks extends Vue {

  get isInErrorState(): boolean {
    return this.$appStore.state.leaderboard.isInErrorState;
  }

  get orderCount(): number {
    return this.$appStore.getters[LEADERBOARD_GETTERS.ORDER_COUNT];
  }

  get isInZeroState(): boolean {
    return this.orderCount === 0 || this.statistics.nationalRankPercentage === 0;
  }

  get statistics(): Statistics {
    return this.$appStore.state.leaderboard.statistics;
  }

  get nationalRankPercentage(): number {
    return this.statistics.nationalRankPercentage;
  }

  get stateRankPercentage(): number {
    return this.statistics.stateRankPercentage;
  }

  get restaurantRankPercentage(): number {
    return this.statistics.restaurantRankPercentage;
  }

  get favoriteRestaurantLocation(): string {
    const favoriteRestaurantCity = this.statistics.favoriteRestaurant.city;
    const stateCode = this.statistics.stateCode;
    return `${favoriteRestaurantCity}, ${stateCode}`;
  }


  get showNationalRank(): boolean {
    return this.nationalRankPercentage <= 30;
  }

  get imageUrl(): string {
    return this.showNationalRank && !this.isInErrorState
      ? this.$appStore.state.cms.images.loyalty.nationalRankBackground.default
      : this.$appStore.state.cms.images.loyalty.stateRankBackground.default;
  }

  get imageMobileUrl(): string {
    return this.showNationalRank && !this.isInErrorState
      ? this.$appStore.state.cms.images.loyalty.nationalRankBackgroundMobile.default
      : this.$appStore.state.cms.images.loyalty.stateRankBackgroundMobile.default;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get stateName(): string {
    return this.statistics.stateRanked;
  }

  get starsImage(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardStatsStars.default;
  }

  get localRankImage(): string | undefined {
    return !this.isMobile 
      ? this.$appStore.state.cms.images.loyalty.leaderboardLocalRank.desktop
      : this.$appStore.state.cms.images.loyalty.leaderboardLocalRank.mobile;
  }

  get nationalRankImage(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardStatsNationalRanks.default;
  }

  get stateRankImage(): string {
    return !this.isInZeroState ? this.statistics.stateImageUri : this.$appStore.state.cms.images.icons.pepperSmall.default;
  }

  get stateRankBoxImage(): string | undefined {
    if (!this.showNationalRank) {
      return !this.isMobile
        ? this.$appStore.state.cms.images.loyalty.leaderboardBlueGreenBoxBrownBorderLong.desktop
        : this.$appStore.state.cms.images.loyalty.leaderboardBlueGreenBoxBrownBorderLong.mobile;
    }
    return !this.isMobile
      ? this.$appStore.state.cms.images.loyalty.leaderboardBlueGreenBoxBrownBorderShort.desktop
      : this.$appStore.state.cms.images.loyalty.leaderboardBlueGreenBoxBrownBorderShort.mobile;
  }

  get nationalRankBoxImage(): string | undefined {
    return !this.isMobile      
      ? this.$appStore.state.cms.images.loyalty.leaderboardGreenYellowBoxBrownBorderShort.desktop
      : this.$appStore.state.cms.images.loyalty.leaderboardGreenYellowBoxBrownBorderShort.mobile;
  }

  get pepperGreyIcon(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardPepperGrey.default;
  }

  get pepperBrownIcon(): string {
    return this.$appStore.state.cms.images.loyalty.leaderboardPepperBrown.default;
  }

  onClickLocalRank(): void {
    this.$services.ui.setModalVisibility('soeRankDescriptionModal', true, { type: 'local' });
    Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
  }

  onClickStateRank(): void {
    this.$services.ui.setModalVisibility('soeRankDescriptionModal', true, { type: 'state' });
    Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
  }

  onClickNationalRank(): void {
    this.$services.ui.setModalVisibility('soeRankDescriptionModal', true, { type: 'national' });
    Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
  }
}
